import { render, staticRenderFns } from "./userImage.vue?vue&type=template&id=b4a92b12&scoped=true"
import script from "./userImage.vue?vue&type=script&lang=js"
export * from "./userImage.vue?vue&type=script&lang=js"
import style0 from "./userImage.vue?vue&type=style&index=0&id=b4a92b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a92b12",
  null
  
)

export default component.exports